import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Assets
import { fonts } from '../../../../styles/variables';
import { updateField } from '../../../../store/ContactForm/actions';

const { detect } = require('detect-browser');

const InputSection = styled.div`
  padding-top: 10px;
  min-height: 50px;
`;

const InputProper = styled.input`
  border-radius: 0;
  width: 100%;
  outline: none;
  background-color: transparent;
  border: 0px;
  font-size: 18px;
  letter-spacing: 1px;
  ${({ color, textColor, textFont, lineHeight }) => `
    line-height: ${lineHeight};
    font-family: ${textFont};
    border-bottom: 1px solid ${color};
    caret-color: ${color};
    color: ${textColor};
    ::placeholder {
      color: ${color};
      font-family: ${fonts.athelas};
      font-style: italic;
    }
  `};
`;

class SimpleInput extends React.PureComponent {
  handleValueChange = event => {
    const { name, form, fields, updateStoreValue } = this.props;
    const { value } = event.target;
    if (fields[[name]].error) {
      updateStoreValue({ name, value: value.slice(-1), form });
    } else {
      updateStoreValue({ name, value, form });
    }
  };

  render() {
    const { name, color, text, fields } = this.props;
    const value = fields[[name]].error ? fields[[name]].error : fields[[name]].value;
    const textColor = fields[[name]].error ? '#FF6347' : color;
    const textFont = fields[[name]].error ? fonts.athelas : fonts.monterrat;
    // IE fix
    const browser = detect();
    const lineHeight = browser.name === 'ie' ? '0px' : '35px';

    return (
      <InputSection>
        <InputProper
          className="simpleForm"
          name={name}
          value={value}
          placeholder={text || name}
          type="text"
          onChange={this.handleValueChange}
          color={color}
          textColor={textColor}
          textFont={textFont}
          lineHeight={lineHeight}
        />
      </InputSection>
    );
  }
}

SimpleInput.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  updateStoreValue: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
  fields: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  fields: state.contactForm.forms[ownProps.form].fields
});

const mapDispatchToProps = dispatch => ({
  updateStoreValue(value) {
    dispatch(updateField(value));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SimpleInput);



// WEBPACK FOOTER //
// ./src/components/ContactForm/Inputs/Simple/index.jsx